<!-- 首页跳转 点击去我 的页面  -->
<template>
  <div
    style="position: absolute; width: 100%; height: 100%; overflow-y: scroll"
  >
    <AlumniCardComponents></AlumniCardComponents>
    <div class="mine">
      <!-- 卡片 -->
      <!-- <div class="mineCardDiv">
      <div class="backgroundImgDiv">
        <img
          src="../../assets/image/btn_beijing_nor.png"
          alt="背景图片"
          class="backgroundImg"
        />
        <div class="mineCard clearfix">
          <div class="photoDiv">
            <img :src="this.mine.url" alt="照片" class="photo" />
          </div>
          <div class="cardData">
            <div class="name">{{ this.mine.name }}</div>
            <div class="schoolAndDissertation clearfix">
              <div class="school">{{ this.mine.school }}</div>
              <div class="dissertation">{{ this.mine.xuejie }}届</div>
              <div class="alumnusId">{{ this.mine.alumnusId }}</div>
            </div>
            <div class="industry">{{ this.mine.hangye }}</div>
          </div>
        </div>
      </div>
    </div> -->
      <!-- 图标导航 -->
      <div class="iconNavDiv">
        <div class="iconNav">
          <div class="myActive" @click="gotoMyActive">
            <img
              src="../../assets/image/btn_huodong_nor.png"
              alt="我的活动"
              class="myActiveImg"
            />
            <div class="myActiveTitle">我的活动</div>
          </div>
          <div class="myFriend" @click="gotoMyAlumni">
            <img
              src="../../assets/image/btn_tongchuang_nor.png"
              alt="同窗好友"
              class="myFriendImg"
            />
            <div class="myFriendTitle">我的好友</div>
          </div>
          <div class="myDonation" @click="gotoMyDonation">
            <img
              src="../../assets/image/btn_juanzeng_nor.png"
              alt="我的捐赠"
              class="myDonationImg"
            />
            <div class="myDonationTitle">我的捐赠</div>
          </div>
          <!-- <div class="myCard" @click="gotoMyWelfareCard">
          <img src="../../assets/image/btn_quanbao_nor.png" alt="我的劵包" class="myCardImg" />
          <div class="myCardTitle">我的劵包</div>
        </div> -->
        </div>
      </div>
      <!-- 功能单元格cell -->
      <div class="cellGroupDiv">
        <div class="cellGroup">
          <van-cell-group>
            <van-cell center title="我的消息" is-link @click="gotoMyNews">
              <!-- <template #title>
              <span class="custom-title">我的消息</span>
              <van-badge :content="20" max="9"> </van-badge>
            </template> -->
              <template #icon>
                <img
                  src="../../assets/image/btn_xiaoxi_nor (1).png"
                  alt="图标"
                  class="icon"
                />
              </template>
            </van-cell>
            <!-- <van-cell center title="我的校友卡" is-link @click="gotoMyAlumniCard">
            <template #icon>
              <img src="../../assets/image/btn_xiaoyouka_nor (1).png" alt="图标" class="icon" />
            </template>
          </van-cell> -->
            <!-- <van-cell center title="我的校友会" is-link @click="gotoMyAlumniMeeting">
            <template #icon>
              <img src="../../assets/image/btn_xiaoyouhui_nor.png" alt="图标" class="icon" />
            </template>
          </van-cell> -->
            <!--   <van-cell center title="我的名片" icon="location-o" is-link @click="gotoMyCard">
            <template #icon>
              <img src="../../assets/image/btn_mingpian_nor.png" alt="图标" class="icon" />
            </template>
          </van-cell> -->
            <van-cell
              center
              title="设置"
              icon="setting-o"
              is-link
              @click="gotoSet"
            >
              <template #icon>
                <img
                  src="../../assets/image/btn_shezhi_nor.png"
                  alt="图标"
                  class="icon"
                />
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </div>

      <!-- 底部标签 -->
    </div>
  </div>
</template>
<script>
import AlumniCardComponents from "@/components/alumniCard/AlumniCardComponents.vue";
import Base64 from "@/utils/base64";

export default {
  components: {
    AlumniCardComponents,
  },
  data() {
    return {
      mine: "",
      bottomCheck: "mine",
      user_id: window.localStorage.getItem("user_id"),
      /* icon: {
        index: require("../../assets/image/btn_shouyehei_nor.png"),
        service: require("../../assets/image/btn_fuwudating_nor.png"),
        mine: require("../../assets/image/btn_wodehei_nor.png"),
      }, */
    };
  },
  created() {
    this.getMine();
  },
  methods: {
    async getMine() {
      let base64 = new Base64()
      const result = await this.$http.get("/my/getBasic", {
        params: { userId: base64.encode(window.localStorage.getItem("user_id")) },
      });
      this.mine = result.data;
    },
    gotoIndex() {
      return this.$router.push("/index");
    },
    gotoSet() {
      return this.$router.push("/mySet");
    },
    gotoMyNews() {
      return this.$router.push("/alumnusActive");
    },
    gotoMyActive() {
      return this.$router.push("/myActive");
    },
    gotoMyAlumni() {
      return this.$router.push("/myAlumni");
    },
    gotoMyWelfareCard() {
      return this.$router.push("/myWelfareCard");
    },
    gotoMyDonation() {
      return this.$router.push("/myDonation");
    },
    gotoMyAlumniCard() {
      return this.$router.push("/alumniCard");
    },
    gotoMyAlumniMeeting() {
      return this.$router.push("/myAlumniMeeting");
    },
    gotoMyCard() {
      return this.$router.push("/myCard");
    },
    gotoService() {
      return this.$router.push("/service");
    },
    /* gotoSiginIn() {
      return this.$router.push("/siginIn");
    }, */
    gotoScenery() {
      window.location.href =
        "http://schoollegant.alumni-resource.com/index.html#/";
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
// .AlumniCardComponents ::before{

//   background-image: url(../../assets/image/cardBackImg.png);
//   background-size: 100%, 100%;
//   border-radius: 15px;

// }

.mine {
  .mineCardDiv {
    .backgroundImgDiv {
      // position: relative;

      width: 100%;

      .backgroundImg {
        width: 100%;
      }

      .mineCard {
        position: absolute;
        width: 90%;
        left: 5%;
        top: 38%;
        background-image: url(../../assets/image/btn_kapian_nor.png);
        background-size: 100% 100%;

        .photoDiv {
          float: left;
          width: 20%;
          height: 18vw;
          padding: 5%;

          .photo {
            width: 100%;
            height: 100%;
            border-radius: 100px;
          }
        }

        .cardData {
          float: left;
          margin-top: 5%;

          .name {
            margin-bottom: 5px;
            font-size: 1.2rem;
            font-weight: bold;
            color: #333333;
          }

          .schoolAndDissertation {
            margin-bottom: 5px;
            font-size: 1.05rem;
            font-weight: 400;
            color: #333333;
            display: flex;
            align-items: center;
            .school {
              margin-right: 10px;
            }
            .dissertation {
              margin-right: 10px;
            }
          }

          .industry {
            font-size: 1.05rem;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
}
.iconNavDiv {
  // position: relative;
  // display: flex;
  justify-content: center;
  margin-top: 20px;

  .iconNav {
    z-index: 100;
    display: flex;
    justify-content: space-around;
    width: 100%;

    .myActive,
    .myFriend,
    .myDonation,
    .myCard {
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .myActiveImg,
      .myFriendImg,
      .myDonationImg,
      .myCardImg {
        position: relative;
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        // width: 60%;
        // height: 10.3vw;
        // max-height: 70px;
        // max-width: 70px;
      }

      .myActiveTitle,
      .myFriendTitle,
      .myDonationTitle,
      .myCardTitle {
        margin-top: 10px;
        font-size: 1.1rem;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}

.cellGroupDiv {
  display: flex;
  justify-content: center;
  margin-top: 20px;

  .cellGroup {
    width: 90%;

    .van-cell-group {
      .van-cell {
        /* .van-badge {
            float: right;
          } */
        .icon {
          width: 4vw;
          height: 4vw;
          max-height: 18px;
          max-width: 18px;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/Mine.vue